import PropTypes from 'prop-types'
import { useState, useEffect, useMemo } from 'react'
import GenericSelect from '../reutilizables/genericSelect/GenericSelect'
import * as categoriasService from '../servicios/categoriasService'

const CaracteristicasProducto = ({
  value,
  onChange,
  idCategoria,
  vieneDeAdministrar
}) => {
  const [metadatos, setMetaDatos] = useState([])

  useEffect(() => {
    const obtenerMetaDatos = async () => {
      if (idCategoria > 0) {
        const { data } = await categoriasService.buscarMetadato(idCategoria)
        setMetaDatos(data.length > 0 ? data : [])
      }
    }

    obtenerMetaDatos()
  }, [idCategoria])

  const metadatosMap = useMemo(() => {
    const map = new Map()

    value.metadatos?.forEach((m) => {
      map.set(m.IdMetaDato, m)
    })

    return map
  }, [value.metadatos])

  const separarValorUnidad = (valor = '') => {
    const texto = String(valor).trim()
    if (!texto) {
      return { valorBase: '', unidad: '' }
    }

    const partes = texto.split(' ')
    if (partes.length === 1) {
      return { valorBase: texto, unidad: '' }
    }

    return {
      valorBase: partes.slice(0, -1).join(' '),
      unidad: partes[partes.length - 1]
    }
  }

  const actualizarMetadato = (idMetadato, valorBase, unidad = '') => {
    const metadatosValues = [...value['metadatos']]
    const indice = metadatosValues.findIndex((m) => m.IdMetaDato === idMetadato)
    const valorFinal = `${valorBase} ${unidad}`.trim()

    if (!valorFinal) {
      if (indice !== -1) {
        metadatosValues.splice(indice, 1)
      }
    } else if (indice !== -1) {
      metadatosValues[indice] = { IdMetaDato: idMetadato, valor: valorFinal }
    } else {
      metadatosValues.push({ IdMetaDato: idMetadato, valor: valorFinal })
    }

    onChange(
      { currentTarget: { name: 'metadatos', value: metadatosValues } },
      'calc',
      metadatosValues
    )
  }

  return (
    <>
      {!vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">
          Cuanta más información tenga la publicación, más fácil será vender el producto.
        </p>
      )}
      {metadatos.map((metadato) => (
        <div key={metadato.idMetaDato} className="row">
          <div className="d-none d-md-block col-md-3 text-right">
            {metadato.etiqueta}:
          </div>
          <div className="d-block d-md-none col-12">{metadato.etiqueta}:</div>
          <div className="col-12 col-md-9">
            {metadato.idMetaDatoTipo === 'boolean' ? (
              <GenericSelect
                options={[
                  { value: 'Si', label: 'Si', key: 'si' },
                  { value: 'No', label: 'No', key: 'no' }
                ]}
                className="w-60"
                name="metadatos"
                value={metadatosMap.get(metadato.idMetaDato)?.valor || ''}
                onChange={(valor) => actualizarMetadato(metadato.idMetaDato, valor)}
              />
            ) : (
              <>
                {(() => {
                  const { valorBase, unidad } = separarValorUnidad(
                    metadatosMap.get(metadato.idMetaDato)?.valor
                  )

                  return (
                    <>
                      <input
                        type={
                          metadato.idMetaDatoTipo === 'number' ||
                          metadato.idMetaDatoTipo === 'number_unit'
                            ? 'number'
                            : 'text'
                        }
                        name={'metadatos'}
                        className="input-text-bordered w-40"
                        value={valorBase}
                        onChange={(e) =>
                          actualizarMetadato(
                            metadato.idMetaDato,
                            e.target.value,
                            metadato.idMetaDatoTipo === 'number' ||
                              metadato.idMetaDatoTipo === 'number_unit'
                              ? unidad
                              : ''
                          )
                        }
                      ></input>
                      {(metadato.idMetaDatoTipo === 'number' ||
                        metadato.idMetaDatoTipo === 'number_unit') && (
                        <input
                          type="text"
                          placeholder="Unidad"
                          name={`unidad_${metadato.idMetaDato}`}
                          className="input-text-bordered w-25"
                          value={unidad}
                          onChange={(e) =>
                            actualizarMetadato(
                              metadato.idMetaDato,
                              valorBase,
                              e.target.value
                            )
                          }
                        />
                      )}
                    </>
                  )
                })()}
              </>
            )}
          </div>
        </div>
      ))}
    </>
  )
}

CaracteristicasProducto.propTypes = {
  value: PropTypes.shape({
    metadatos: PropTypes.array
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  idCategoria: PropTypes.number.isRequired,
  vieneDeAdministrar: PropTypes.bool
}

export default CaracteristicasProducto
